import { Outlet } from 'react-router-dom'

const Category = () => <Outlet />

export default Category
